var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n    absolute\n    left-0\n    top-0\n    z-10\n    max-w-max\n    h-full\n    pb-12\n    bg-gradient-to-r\n    from-black\n    to-transparent\n  "},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }